/**
 * Shared premium surface styles for the user/admin dashboard zones, so cards
 * read as one cohesive system (rounded, soft border, hover lift). Pass a theme.
 */

// A resting content panel.
export const panelSx = (theme) => ({
  p: { xs: 2.5, md: 3 },
  borderRadius: 4,
  border: `1px solid ${theme.palette.grey[200]}`,
  bgcolor: theme.palette.background.paper,
  boxShadow: 'none',
});

// An interactive card that lifts on hover.
export const hoverCardSx = (theme) => ({
  borderRadius: 4,
  border: `1px solid ${theme.palette.grey[200]}`,
  bgcolor: theme.palette.background.paper,
  overflow: 'hidden',
  transition: 'transform 0.25s ease, box-shadow 0.25s ease',
  '&:hover': { transform: 'translateY(-4px)', boxShadow: theme.shadows[8] },
});
